import React, { useEffect } from 'react';
import house from '../../images/Capture1.PNG'
import tour from '../../images/Capture2.PNG'
import macbook from '../../images/Capture3.PNG'
import Aos from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';


const Project = () => {
    useEffect(() => {
        Aos.init()
    })
    return (
        <div className="mt-20">

<h1 
data-aos="fade-up"
data-aos-duration="3000"
className="text-4xl font-bold text-blue-500 mb-10">Some of my Projects</h1>
            <div className="grid lg:grid-cols-3 bg-gray-300">
            <div data-aos="fade-up"
             data-aos-duration="3000"
             className="  border-solid border-4 border-light-blue-500 mx-4 my-4 shadow-2xl rounded-xl">
        <img className="px-10 py-5" src={house} alt="" />
        <div className="mb-3">
        <p className="text-justify text-xl px-10  mb-5"> A full-stack single-page property selling web app where people can take and book properties. Login system with firebase and private routes. Dashboard for users and admins where admins can do CRUD operations and users can give reviews and monitor their booking list. </p>
        <button className="px-2 py-1 bg-gray-400 ">React.js</button> 
        <button className="px-2 py-1 bg-gray-400 mx-1">React Tailwind</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Node.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Express.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">MongoDB</button>
        <button className="px-2 py-1 bg-gray-400 mx-1 mt-1">Firebase Authentication</button>
        </div>
        <Link to="/buyingHouse">
        <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl">See Details</button>
            </Link>

            </div>
            <div
            data-aos="fade-up"
            data-aos-duration="3000"
            className=" border-solid border-4 border-light-blue-500 mx-4 my-4 shadow-2xl rounded-xl">
                <img className="px-10 py-5" src={tour} alt="" />
                <div className="mb-3">
                    <p  className="text-justify text-xl px-10 mb-7">A full-stack single-page touring web app. Login system with firebase and private routes. Users can book packages and see their purchase records on the order page. Admin panel, where admin can do CRUD operations.</p>
                    <button className="px-2 py-1 bg-gray-400 ">React.js</button> 
        <button className="px-2 py-1 bg-gray-400 mx-1">React Tailwind</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Node.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Express.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">MongoDB</button>
        <button className="px-2 py-1 bg-gray-400 mx-1 mt-2">Firebase Authentication</button>
                </div>
                
                <Link to="/gTour">
        <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mt-2">See Details</button>
            </Link>

            </div>
            <div
            data-aos="fade-up"
            data-aos-duration="3000"
            className=" border-solid border-4 border-light-blue-500 mx-4 my-4 shadow-2xl rounded-xl">
                <img className="px-10 py-5" src={macbook} alt="" />
                <div className="mb-3">
                    <p  className="text-justify text-xl px-10 mb-20">A full-stack single-page purchasing web app. Users can buy electronics parts and see their purchase records. There is a cupon code for 10% discount.</p>
                    <button className="px-2 py-1 bg-gray-400 ">JavaScript</button> 
        <button className="px-2 py-1 bg-gray-400 mx-1">Bootstrap</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Cupon System</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Express.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1 mt-2">MongoDB</button>

                </div>
                <Link to="/macOs">
        <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mt-2">See Details</button>
            </Link>
            </div>
            
        </div>

        <div data-aos="fade-up"
            data-aos-duration="3000" >
        <Link to="/projects">
        <button className="bg-red-600 rounded px-5 py-2  text-white text-xl">See More</button>
            
            </Link>  
        </div>
        </div>
        
    );
    
};

export default Project;